var $6db19998ba4427da$exports = {};
$6db19998ba4427da$exports = {
  "ascending": "stigande",
  "ascendingSort": function ascendingSort(args) {
    return "sorterat p\xE5 kolumn ".concat(args.columnName, " i stigande ordning");
  },
  "columnSize": function columnSize(args) {
    return "".concat(args.value, " pixlar");
  },
  "descending": "fallande",
  "descendingSort": function descendingSort(args) {
    return "sorterat p\xE5 kolumn ".concat(args.columnName, " i fallande ordning");
  },
  "resizerDescription": "Tryck p\xE5 Retur f\xF6r att b\xF6rja \xE4ndra storlek",
  "select": "Markera",
  "selectAll": "Markera allt",
  "sortable": "sorterbar kolumn"
};
export { $6db19998ba4427da$exports as default };